import type { KeyedMarketDataSnapshot } from '@talos/kyoko';
import type { ICellRendererParams } from 'ag-grid-community';
import { getPriceGridMarketDataRequest } from '../../../columns/marketData';
import type { PriceGridEntity } from '../../../PriceGridEntity';

export function getPriceGridMarketDataSnapshotForCell(
  params: Pick<ICellRendererParams<PriceGridEntity>, 'data' | 'column'>
): KeyedMarketDataSnapshot | undefined {
  if (!params.data || !params.column) {
    return undefined;
  }

  const request = getPriceGridMarketDataRequest(params.column, params.data);
  if (!request) {
    return undefined;
  }

  return params.data.marketData[request.key];
}
